import { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { UserContext } from "../context/userContext";

function Sidebar() {
  const { user, sidebarOpen, closeSidebar } = useContext(UserContext);
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();

  const permissions = user?.permissions || {};
  const isActive = (path) => location.pathname === path;
  const canView = (module) => permissions[module]?.includes("View");

  return (
    <>
      {/* Mobile Backdrop */}
      <div
        className={`fixed inset-0 bg-black/40 backdrop-blur-sm z-40 transition-opacity duration-300 md:hidden ${
          sidebarOpen ? "opacity-100 visible" : "opacity-0 invisible"
        }`}
        onClick={closeSidebar}
      ></div>

      {/* Sidebar */}
      <div
        className={`
          fixed top-0 left-0 h-full bg-white/90 backdrop-blur-lg border-r border-gray-200/50 shadow-2xl 
          flex flex-col transition-all duration-500 ease-in-out z-50
          ${collapsed ? "w-20" : "w-64"}
          md:translate-x-0
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
        `}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gradient-to-r from-sky-50 to-indigo-50">
          <div className="flex items-center space-x-3">
            <img
              src="https://pgbackend.nmcelogbook.com/uploads/logo/1744180403984.png"
              alt="Logo"
              className="w-10 h-10 rounded-lg shadow-md hover:scale-110 transition-transform duration-300"
            />

            {!collapsed && (
              <h5 className="font-semibold text-gray-800 text-lg tracking-wide hidden sm:block">
                NMC eLogbook
                <div className="text-sm text-purple-500">
                  {user?.roleId?.name || ""}
                </div>
              </h5>
            )}
          </div>

          {/* Collapse Button */}
          <button
            onClick={() => setCollapsed(!collapsed)}
            className="text-gray-600 hover:text-indigo-600 hover:scale-110 transition-transform hidden md:block"
          >
            <i
              className={`ti ${
                collapsed ? "ti-arrow-bar-right" : "ti-arrow-bar-left"
              }`}
            ></i>
          </button>
        </div>

        {/* Menu */}
        <ul className="flex-1 mt-3 space-y-1 overflow-y-auto px-2 custom-scrollbar">
          {Object.keys(permissions).map(
            (key) =>
              canView(key) && (
                <li key={key}>
                  <Link
                    to={`/${key.toLowerCase().replace(/\s+/g, "_")}`}
                    onClick={closeSidebar}
                    className={`flex items-center gap-3 px-4 py-2 rounded-xl transition-all duration-300 ${
                      isActive(`/${key.toLowerCase().replace(/\s+/g, "_")}`)
                        ? "bg-gradient-to-r from-sky-500 to-indigo-500 text-white shadow-lg scale-[1.02]"
                        : "hover:bg-gradient-to-r hover:from-sky-100 hover:to-indigo-100 text-gray-700"
                    }`}
                  >
                    <i className={`ti ti-${getIconFor(key)} text-xl`}></i>
                    {!collapsed && <span className="font-medium">{key}</span>}
                  </Link>
                </li>
              )
          )}
        </ul>

        {/* Footer */}
        <div className="p-4 border-t border-gray-100 bg-white/60 text-sm text-center text-gray-500 backdrop-blur-md">
          {!collapsed ? (
            <p className="text-gray-600">© {2025} Neugenic Mediventure Collective Private Limited</p>
          ) : (
            <i className="ti ti-copyright text-gray-600"></i>
          )}
        </div>
      </div>
    </>
  );
}

// Icon mapping
function getIconFor(name) {
  const icons = {
    Dashboard: "layout-dashboard",
    Roles: "id-badge",
    Permissions: "lock",
    Student: "users",
    Staff: "users",
    Reports: "file-text",
    Settings: "settings",
    Departments: "building-bank",
    Skill: "tools",
    Aetcom: "heart-rate-monitor",
    Appraisal: "chart-bar",
    Thesis: "book-2",
    Logbook: "notebook",
  };
  return icons[name] || "menu";
}

export default Sidebar;

